import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { ActionSheetController, Platform, IonTextarea } from '@ionic/angular';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
// import { FilePath } from '@awesome-cordova-plugins/file-path/ngx';
// import { FileChooser } from '@awesome-cordova-plugins/file-chooser/ngx';
import { FileHelpersService } from 'src/app/core/services/file-helpers/file-helpers.service';
import { RequestCreationService } from 'src/app/core/services/request-creation/request-creation.service';
import { UtilsService } from 'src/app/core/services/utils/utils.service';
import { MIMETypesEnum } from 'src/app/models/mimetype.enum';
import { File, FileEntry } from '@awesome-cordova-plugins/file/ngx';
import { DomSanitizer } from '@angular/platform-browser';
// import { Chooser } from '@awesome-cordova-plugins/chooser/ngx';
import { Directory, Filesystem } from '@capacitor/filesystem';
@Component({
  selector: 'cc-addedd-flaw',
  templateUrl: './addedd-flaw.component.html',
  styleUrls: ['./addedd-flaw.component.scss'],
})
export class AddeddFlawComponent implements OnInit {

  @Input() flaw;
  @Input() failureIdentifier;
  @Output() deletedFlawId = new EventEmitter<number>();

  @ViewChild('file', { static: false }) fileBrowser;
  @ViewChild('input', { static: false }) inputElement: IonTextarea;

  // @ViewChild('input', { static: false }) textarea: ElementRef;

  public addObservation: boolean = false;
  public observation: string = '';
  private window: any = window;
  public files: Array<any> = [];
  public temp = ['https://gravatar.com/avatar/',
    'https://gravatar.com/avatar/dba6bae8c566f9d4041fb9cd9ada7741?d=identicon&f=y']//, '../../../assets/imgs/icon.png',
  // '../../../assets/imgs/bg.jpeg', '../../../assets/imgs/bg.png'];
  public plt: string = 'mobile';
  public obsCharsCount: number = 0;

  constructor(
    private actShCtlr: ActionSheetController,
    private platform: Platform,
    private ref: ChangeDetectorRef,
    // private fileChooser: FileChooser,
    private fileHelper: FileHelpersService,
    public camera: Camera,
    // private filePath: FilePath,
    private requestCreationService: RequestCreationService,
    private utils: UtilsService,
    private elementRef: ElementRef,
    private file: File,
    private sanitizer: DomSanitizer,
    private translate : TranslateService
    // private chooser: Chooser
  ) { }

  async ngOnInit() {
    this.flaw.itemSpot = this.flaw.itemSpot.substring(this.flaw.itemSpot.indexOf('/') + 1).trim();
    this.plt = this.platform.is('android') || this.platform.is('ios') ? 'mobile' : 'desktop';
    try {
      this.files = await this.utils.getFromStorage(`failureFiles[${this.failureIdentifier}]`);
      this.flaw.attachments = this.files.map(el => el.name);
    } catch (e) {
      console.log('Doesnt have files');
    }

  }

  async openOptions() {
    let buttons = [];
    if (this.platform.is('android') || this.platform.is('ios')) {
      buttons.push({
        text: this.translate.instant('addedd-flaw.Cámara'),
        icon: 'camera',
        cssClass: 'camera requests-action-sheet-button',
        handler: () => {
          this.getPicture(this.camera.PictureSourceType.CAMERA);
        }
      }, {
        text: this.translate.instant('addedd-flaw.Galería'),
        icon: 'image',
        cssClass: 'requests-action-sheet-button',
        handler: () => {
          this.getPicture(this.camera.PictureSourceType.PHOTOLIBRARY);
        }
      }/*, {
        text: 'Documento',
        icon: 'document',
        cssClass: 'requests-action-sheet-button',
        handler: () => {
          if (this.checkNumberOfFiles()) {

            if (this.platform.is('android')) {
              this.fileChooser.open()
                .then(
                  uri => {
                    this.filePath.resolveNativePath(uri)
                      .then(async (file) => {
                        let newEntry = { name: '', path: '', filePath: '', temp: '' };
                        const extension = this.utils.getFileExtension(file);
                        newEntry.name = this.fileHelper.setNewFileName(extension);

                        // if (extension === 'pdf') {
                        newEntry.filePath = file;
                        this.addFile(newEntry);
                        // } else {
                        //   const correctPath = file.substr(0, file.lastIndexOf('/') + 1);
                        //   const currentName = file.substring(file.lastIndexOf('/') + 1);
                        //   const entry = await this.fileHelper.copyFileToLocalDir(correctPath, currentName, newEntry.name);
                        //   newEntry.filePath = entry['filePath']
                        //   newEntry.temp = entry['path'];
                        //   this.addFile(newEntry);
                        // }

                      })
                      .catch(err => console.log(err));
                  }
                )
                .catch(error => {
                  console.log(error)
                })
            } else {
              this.filePicker.pickFile()
                .then(async (uri) => {
                  let newEntry = { name: '', path: '', filePath: '', temp: '' };
                  const extension = this.utils.getFileExtension(uri);
                  newEntry.name = this.fileHelper.setNewFileName(extension);
                  const correctPath = `file:///${uri.substr(0, uri.lastIndexOf('/') + 1)}`;
                  const currentName = uri.substring(uri.lastIndexOf('/') + 1);
                  const entry = await this.fileHelper.copyFileToLocalDir(correctPath, currentName, newEntry.name);
                  newEntry.filePath = entry['filePath']
                  newEntry.temp = entry['path'];
                  this.addFile(newEntry);
                })
                .catch(err => console.log('Error', err));
            }

          }
        }
      }*/
      );
    } else
      buttons.push({
        text: this.translate.instant('addedd-flaw.Agregar archivo'),
        cssClass: 'requests-action-sheet-button',
        icon: 'attach',
        handler: () => {
          if (this.checkNumberOfFiles())
            this.fileBrowser.nativeElement.click();
        }
      })

    const actionSheet = await this.actShCtlr.create({
      buttons: [...buttons, {
        text: this.translate.instant('addedd-flaw.Eliminar falla'),
        role: 'destructive',
        handler: () => {
          this.deleteFlaw();
        }
      }, {
        text: this.translate.instant('addedd-flaw.Cancelar'),
        role: 'cancel',
      }]
    });
    await actionSheet.present();
  }

  async deleteFlaw(slidingItem?) {
    await this.utils.removeFromStorage(`failureFiles[${this.failureIdentifier}]`);
    this.deletedFlawId.emit(this.failureIdentifier);
  }

  showObsInput() {
    this.addObservation = !this.addObservation;
    setTimeout(() => {
      this.inputElement.setFocus();
    }, 250);
  }

  saveObservation(keyPress?) {
    if (!keyPress || keyPress.keyCode === 13) {
      this.flaw.observation = this.observation ? this.observation : this.translate.instant('addedd-flaw.Sin observación');
      this.addObservation = false;
    }

    const textarea = this.elementRef.nativeElement.querySelector('.obs-textarea');
    this.obsCharsCount = textarea.value.length;
  }

  async getPicture(source) {
    if (this.checkNumberOfFiles()) {
      try {
        let newEntry = source === 1 ? await this.fileHelper.takePicture() : await this.fileHelper.choosePicture();
        newEntry['temp'] = newEntry['path'];
        this.addFile(newEntry)
      } catch (e) {
        console.log(e);
      }
    }
  }

  selectedFileBrowser(file) {
    const extension = this.utils.getFileExtension(file.name)
    const newFileName = this.fileHelper.setNewFileName(`.${extension}`);
    const newEntry = {
      name: newFileName
    };
    newEntry['availability'] = false;
    newEntry['path'] = '../../../../assets/imgs/loader.gif';

    this.files = [newEntry, ...this.files];
    this.flaw.attachments = this.files.map(el => {
      return {
        name: el.name,
        availability: el.availability
      }
    });
    this.ref.detectChanges();
    this.requestCreationService.updateFiles();

    this.requestCreationService.getS3PreSignedUrl(newEntry.name, MIMETypesEnum[this.utils.getFileExtension(newEntry.name)])
      .subscribe(async ({ data, error, operation }) => {
        if (error) {
          this.utils.showMessage(`${operation}. ${this.translate.instant('addedd-flaw.Agregar nuevamente')}`);
          this.files.shift();
          this.requestCreationService.updateFiles();
        } else {
          this.requestCreationService.uploadImageToS3FromWeb(data, file).subscribe(async (upload) => {
            if (upload && upload.error) {
              this.utils.showMessage(`${operation}. ${this.translate.instant('addedd-flaw.Agregar nuevamente')}`);
              this.files.shift();
              this.requestCreationService.updateFiles();
            } else {
              const reader = this.getFileReader();
              reader.onload = (e) => {
                let index = this.files.findIndex(el => el.name === newEntry.name);
                this.files[index].name = data.path
                const img = this.utils.getImage(this.utils.getFileExtension(file.name));
                this.files[index].path = img ? img : e['target']['result'];
                this.files[index].availability = true;
                this.flaw.attachments = this.files.map(el => {
                  return {
                    name: el.name,
                    availability: el.availability
                  }
                });
                this.requestCreationService.updateFiles();
                this.ref.detectChanges();
              };
              reader.readAsDataURL(file);
            }
          })
        }
      });
  }


  addFile(newEntry, selectedFile?) {
    newEntry['availability'] = false;
    newEntry['path'] = '../../../../assets/imgs/loader.gif';

    this.files = [newEntry, ...this.files];
    this.flaw.attachments = this.files.map(el => {
      return {
        name: el.name,
        availability: el.availability
      }
    });
    this.ref.detectChanges();
    this.requestCreationService.updateFiles();
    this.requestCreationService.getS3PreSignedUrl(newEntry.name, MIMETypesEnum[this.utils.getFileExtension(newEntry.name)]).subscribe(({ data, error, operation }) => {
      if (error) {
        this.utils.showMessage(`${operation}. ${this.translate.instant('addedd-flaw.Agregar archivo nuevamente')}`);
        this.files.shift();
      } else {
        newEntry.realName = newEntry.name;
        newEntry.name = data.path;
        if (newEntry.filePath) {
          this.readFileApp(newEntry, data)
        } else
          this.readFile(selectedFile, data.url, newEntry)
      }
    })
  }

  async readFileApp(entry, s3Data) {
    const file = await Filesystem.readFile({
      path: entry.realName,
      directory: Directory.Data
    });
    const blob = this.fileHelper.b64toBlob(file.data, 'image/png');
    this.manageUpload(entry, s3Data, blob)
  }

  readFile(file: any, data, entry) {
    const reader = this.getFileReader();

    reader.onload = async () => {
      const imgBlob = new Blob([reader.result], {
        type: file.type
      });
      this.manageUpload(entry, data, imgBlob)
    }

    reader.readAsArrayBuffer(file);
  }

  manageUpload(entry, s3Data, imgBlob) {
    this.requestCreationService.uploadImageToS3FromWeb(s3Data, imgBlob).subscribe(async (upload) => {

      const index = this.files.findIndex(el => el.name === entry.name)
      if (upload && upload.error) {
        this.utils.showMessage(this.translate.instant('addedd-flaw.Error al subir archivo. Agregar nuevamente'));
        this.files[index].name = '';
        this.files[index].availability = true;
        this.files.shift();
      } else {
        this.files[index].name = entry.name;

        if (entry.temp)
          this.files[index].path = entry.temp;
        else {
          const img = this.utils.getImage(this.utils.getFileExtension(this.files[index].name))
          this.files[index].path = img
        }
        this.files[index].availability = true;
      }
      this.files[index].availability = true;
      this.flaw.attachments = this.files.map(el => {
        return {
          name: el.name,
          availability: el.availability
        }
      });
      this.requestCreationService.updateFiles();
      this.ref.detectChanges();
    });
  }


  async deleteFile(file) {
    const fileToDeleteIndex = this.files.findIndex(el => file.name === el.name);
    if (this.files[fileToDeleteIndex].availability) {
      const actionSheet = await this.actShCtlr.create({
        buttons: [{
          text: this.translate.instant('addedd-flaw.Eliminar archivo'),
          icon: 'trash',
          role: 'destructive',
          handler: () => {
            this.files.splice(fileToDeleteIndex, 1);
            this.flaw.attachments = this.files.map(el => {
              return {
                name: el.name,
                availability: el.availability
              }
            });
          }
        }, {
          text: this.translate.instant('addedd-flaw.Cancelar'),
          icon: 'close',
          role: 'cancel',
        }]
      });
      await actionSheet.present();
    }
  }

  checkNumberOfFiles() {
    if (this.files.length === 5) {
      this.utils.showMessage(this.translate.instant('addedd-flaw.No puede adjuntar más de 5 archivos'))
      return false;
    }
    return true;
  }

  openFile(file) {
    if (this.platform.is('android') || this.platform.is('ios')) {
      let tempFile = JSON.parse(JSON.stringify(file));
      tempFile.name = tempFile.realName;
      this.fileHelper.openFile(tempFile);
    }

  }

  returnFlaw() {
    return this.flaw;
  }

  getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
    return zoneOriginalInstance || fileReader;
  }

}



